module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/business-calculator/business-calculator.component.css
// module id = ./src/app/components/calculator/calculator-item/business-calculator/business-calculator.component.css
// module chunks = main